<c-container style="height:60vh; padding-left:0; padding-right:0">
    <optima-data-query-rules-editor 
        (onSelectionValidationCheck)="onSelectionsValidationCheck($event)" 
        (onGroupByValidationCheck)="onGroupBysValidationCheck($event)" 
        (onFilterValidationCheck)="onFilterExpressionsValidationCheck($event)"
        (onSelectionsChange)="onSelectionsChange($event)"
        (onGroupBysChange)="onGroupBysChange($event)"
        (onFilterExpressionsChange)="onFilterExpressionsChange($event)"
        (onMoreChange)="onMoreChange($event)"
        (onStatusFieldAliasChanged)="onStatusFieldAliasChanged($event)"
        [selections]="selections | async"
        [preDefinedReferences]="preDefinedReferences | async"
        [groupBys]="groupBys | async"
        [filterExpressions]="filterExpressions | async"
        [more]="(more | async)!"
        [selectedStatusFieldAlias]="selectedStatusFieldAlias"
        [isProgressKpi]="isProgressKpi"
        [viewOnly]="viewOnly"
        >
    </optima-data-query-rules-editor>
</c-container>